const currencyFlags = {
  USD: '🇺🇸', EUR: '🇪🇺', CNY: '🇨🇳', CNH: '🇨🇳', HKD: '🇭🇰', JPY: '🇯🇵',
  GBP: '🇬🇧', AUD: '🇦🇺', CAD: '🇨🇦', CHF: '🇨🇭', NZD: '🇳🇿', SGD: '🇸🇬',
  KRW: '🇰🇷', INR: '🇮🇳', BRL: '🇧🇷', MXN: '🇲🇽', ZAR: '🇿🇦', TRY: '🇹🇷'
}

const brandColors = {
  BTC: '#f7931a', ETH: '#627eea', USDT: '#26a17b', BNB: '#f3ba2f', XRP: '#23292f',
  SOL: '#7b61ff', DOGE: '#c2a633', ADA: '#3468d4', TRX: '#ef0027', DOT: '#e6007a',
  AAPL: '#555555', TSLA: '#e82127', MSFT: '#00a4ef', AMZN: '#ff9900', META: '#0866ff',
  NVDA: '#76b900', NFLX: '#e50914', GOOG: '#4285f4', GOOGL: '#4285f4'
}

function hashColor(value) {
  let hash = 0
  for (let i = 0; i < value.length; i++) hash = value.charCodeAt(i) + ((hash << 5) - hash)
  return `hsl(${Math.abs(hash) % 360}, 62%, 44%)`
}

function svgData(svg) {
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
}

function cleanCode(item) {
  return String((item && (item.code || item.symbol || item.productCode)) || 'LMAX')
    .toUpperCase().replace(/[^A-Z0-9]/g, '')
}

function badge(text, background, foreground = '#fff', secondary = '') {
  const safeText = text.slice(0, 5)
  return svgData(`<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
    <rect width="72" height="72" rx="20" fill="${background}"/>
    <circle cx="57" cy="15" r="9" fill="rgba(255,255,255,.18)"/>
    <text x="36" y="41" text-anchor="middle" font-family="Arial,sans-serif" font-size="${safeText.length > 3 ? 17 : 23}" font-weight="700" fill="${foreground}">${safeText}</text>
    ${secondary ? `<text x="36" y="59" text-anchor="middle" font-family="Arial,sans-serif" font-size="9" fill="rgba(255,255,255,.78)">${secondary}</text>` : ''}
  </svg>`)
}

function forexLogo(code) {
  const compact = code.replace(/[^A-Z]/g, '')
  const base = compact.slice(0, 3)
  const quote = compact.slice(3, 6)
  if (!currencyFlags[base] || !currencyFlags[quote]) return null
  return svgData(`<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
    <rect width="72" height="72" rx="20" fill="#101216"/>
    <text x="25" y="34" text-anchor="middle" font-size="27">${currencyFlags[base]}</text>
    <text x="48" y="49" text-anchor="middle" font-size="27">${currencyFlags[quote]}</text>
    <path d="M18 54h36" stroke="#fff" stroke-opacity=".22" stroke-width="2"/>
  </svg>`)
}

/**
 * 产品 Logo 只由前端代码生成，不读取接口返回的第三方 logo 地址。
 * 未收录的新产品也会按代码和类型生成稳定徽标，保证所有产品均有图片。
 */
export function getMarketLogo(item = {}) {
  const code = cleanCode(item)
  const type = Number(item.type || item.marketType || 0)
  const forex = forexLogo(code)
  if (type === 1 && forex) return forex

  if (/^(XAG|SILVER|AG)/.test(code)) return badge('Ag', '#7b8794', '#ffffff', 'SILVER')
  if (/^(XPT|PLATINUM|PT)/.test(code)) return badge('Pt', '#6f7f89', '#ffffff', 'PLATINUM')
  if (/^(XPD|PALLADIUM|PD)/.test(code)) return badge('Pd', '#596b7b', '#ffffff', 'PALLADIUM')
  if (type === 5 || /^(XAU|GOLD|AU)/.test(code)) return badge('Au', '#c99826', '#fff7d1', 'GOLD')

  if (type === 2) {
    const coin = code.replace(/(USDT|USD|USDC|BUSD|BTC|EUR)$/, '') || code.slice(0, 4)
    const mark = coin === 'BTC' ? '₿' : coin === 'ETH' ? '◆' : coin.slice(0, 4)
    return badge(mark, brandColors[coin] || hashColor(coin), '#fff', coin)
  }

  const shortCode = code.split(/USDT|USD/)[0].slice(0, 5) || 'LMAX'
  if (type === 3) return badge(shortCode, brandColors[shortCode] || hashColor(shortCode), '#fff', 'STOCK')
  if (type === 4) return badge(shortCode, hashColor(`F${shortCode}`), '#fff', 'FUTURES')
  if (type === 6) return badge(shortCode, hashColor(`E${shortCode}`), '#fff', 'ETF')
  return forex || badge(shortCode, brandColors[shortCode] || hashColor(shortCode), '#fff', 'MARKET')
}

export function applyMarketLogos(items) {
  return (Array.isArray(items) ? items : []).map(item => ({ ...item, logo: getMarketLogo(item) }))
}
